import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { COLOR, THEME } from '../../constants/styles';

import { Container, NextButton, OPComponent } from '../components';
import SelectCasesAndGroups from './select_cases_and_groups';
import { connect } from 'react-redux';
import { REQUESTING } from '../../actions/statusTypes';
import DeploymentForm from './deployment_form';

const subScreenRef = React.createRef();

class SelectSplitScreen extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      formReady: false,
    };
  }

  formReady = () => {
    return this.haveSelection() && subScreenRef?.current?.validateForm();
  };

  haveSelection = () => {
    if (!this.props.selectedCases) return false;
    const dataReady = Object.keys(this.props.selectedCases).reduce((result, k) => {
      return result || !!this.props.selectedCases[k]?.length;
    }, false);
    return dataReady;
  };

  handleSubscreenInputsChange = () => {
    if (this.formReady() && !this.state.formReady) {
      this.setState({ formReady: true });
    }
  };

  handleNextPressed = () => {
    if (this.formReady()) {
      subScreenRef?.current?.onSave();
    }
  };

  render() {
    const { subScreen } = this.props;
    const SubScreen = DeploymentForm;
    return (
      <Container
        style={[
          THEME.container,
          {
            flexDirection: 'column',
          },
        ]}
        scrollView={true}
        renderActivityOverlay={this.props.status === REQUESTING}
      >
        <View style={{ flexDirection: 'row' }}>
          <View
            style={{
              flex: 0.35,
              borderRightColor: COLOR.text,
              borderRightWidth: 1,
            }}
          >
            <SelectCasesAndGroups {...this.props} hideNext />
          </View>
          <View
            style={{
              flex: 0.65,
            }}
          >
            {subScreen && (
              <View>
                <View>
                  <SubScreen
                    {...subScreen.passProps}
                    ref={subScreenRef}
                    onInputsChanged={this.handleSubscreenInputsChange}
                    inSplitScreen={true}
                  />
                </View>

                <View
                  style={{
                    height: 40,
                    width: 200,
                    marginHorizontal: 'auto',
                    marginVertical: 10,
                  }}
                >
                  <NextButton
                    onPress={this.handleNextPressed}
                    disabled={!this.haveSelection()}
                    label="Schedule"
                  />
                </View>
              </View>
            )}
          </View>
        </View>
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    status: state.screens.calendar.status,
    selectedCases: state.screens.calendar.selectedCases,
  };
}

export default connect(mapStateToProps, null)(SelectSplitScreen);
